import React from "react";
import { useReveal } from "../hooks/useReveal";

// Wrapper that fades/slides children in on scroll
const Reveal = ({ children, className = "", delay = 0, as: Tag = "div" }) => {
  const { ref, visible } = useReveal();
  return (
    <Tag
      ref={ref}
      className={`reveal ${visible ? "is-visible" : ""} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default Reveal;
